import { render } from "./SidePanel.vue?vue&type=template&id=85c2bb94&lang=pug"
import script from "./SidePanel.js?vue&type=script&lang=js&external"
export * from "./SidePanel.js?vue&type=script&lang=js&external"

import "./SidePanel.vue?vue&type=style&index=0&id=85c2bb94&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__